<template>
  <section>
    <qx-search-box
        class="searchBox"
        ref="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery=""
    >
    <div slot="titleLeft" class="titleDesc">报账模式的订单，司机上报费用统计分析</div>
    </qx-search-box>
    <TableBox ref="tableBox" :dependTime="dependTime" :orgId="orgId"/>
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
} from 'api';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      dependTime: '',
      orgId: '',
      searchBoxData: {
        // 归属部门
        orgIdOptions: [],
        form: [
          {
            label: '主驾姓名',
            value: 'carDriverMan',
            type: 'input',
            placeholder: '请输入主驾姓名',
          },
          {
            label: '主驾电话',
            value: 'carDriverPhone',
            type: 'input',
            placeholder: '请输入主驾电话',
          },
          // {
          //   label: '副驾姓名',
          //   value: 'plateNumber',
          //   type: 'input',
          //   placeholder: '请输入副驾姓名',
          // },
          // {
          //   label: '副驾电话',
          //   value: 'linkman',
          //   type: 'input',
          //   placeholder: '请输入副驾电话',
          // },
          {
            label: '发车时间',
            value: 'dependTime',
            type: 'date',
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请输入归属部门',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    sub (searchBoxData) {
      this.dependTime = searchBoxData.dependTime || '';
      this.orgId = searchBoxData.orgId || '';
      // 发车时间
      if (searchBoxData.dependTime && searchBoxData.dependTime.length > 0) {
        searchBoxData.dependTimeBegin = this.formatDate(searchBoxData.dependTime[0]);
        searchBoxData.dependTimeEnd = this.formatDate(searchBoxData.dependTime[1]);
        delete searchBoxData.dependTime;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...((await getDepartmentAllList({
        pid: '',
      })) || []),
    ];
  },
};
</script>

<style scoped lang="scss">
.vehicleStatus-select {
  display: flex;
}
.titleDesc{
      margin-top: -2.2rem;
    margin-bottom: 2rem;
    color: red;
    padding-left: 5rem;
}
</style>
